export default __webpack_public_path__ + "static/media/slide-2.a21dc1e0.jpg";